import { render, staticRenderFns } from "./cms-plugins-liquid-renderer.vue?vue&type=template&id=bd82f25e"
import script from "./cms-plugins-liquid-renderer.vue?vue&type=script&lang=js"
export * from "./cms-plugins-liquid-renderer.vue?vue&type=script&lang=js"
import style0 from "./cms-plugins-liquid-renderer.vue?vue&type=style&index=0&id=bd82f25e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports